class Variables {
    static techStacks = [
        "WordPress",
        "Drupal",
        "Magento",
        "Shopify",
        "Laravel",
        "AWS",
        "QA",
        "HTML Email Development",
        "Design",
        "Frontend Development",
        "React Native",
        "Flutter",
        "Android/iOS",
        "MERN",
        "ReactJs",
        "NodeJs",
      ];
}
export default Variables;